import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import axios from "axios";
import API from "../helpers/api";
import swal from "sweetalert";

let currentUser = JSON.parse(localStorage.getItem("currentUser"));
class newFleetManager extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fleetManagerInfo: {
        clientId: 0,
        userRole: "fleetmanager",
        userName: "",
        email: "",
        telephone: "",
        createdBy: currentUser.email,
      },
      index: 0,
      fleetManagerArray: [],
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.updateFleetManager = this.updateFleetManager.bind(this);
    this.addFleetManager = this.addFleetManager.bind(this);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { fleetManagerList, fleetManagerDetail, dispatch } = nextProps;
    if (fleetManagerDetail) {
      prevState.fleetManagerInfo.userName = fleetManagerDetail.userName;
      prevState.fleetManagerInfo.email = fleetManagerDetail.email;
      prevState.fleetManagerInfo.telephone = fleetManagerDetail.telephone;
      if (fleetManagerList) {
        prevState.index = fleetManagerList?.findIndex(
          (x) => x.email === fleetManagerDetail.email
        );
      }

      dispatch({ type: "GetFleetManagerDetails", data: null });
    }
    if (fleetManagerList) {

      prevState.fleetManagerArray = fleetManagerList;
    }
  }

  handleInputChange(e) {
    let nodeName = e.target.name;
    this.state.fleetManagerInfo[nodeName] = e.target.value;
    this.setState({});
  }

  addFleetManager() {
    let emailregex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const {
      dispatch,
      fleetManagerList,
      techSuperintendentList,
      techExecutiveList,
    } = this.props;
    if (this.state.fleetManagerInfo.email !== "") {
      if (emailregex.test(this.state.fleetManagerInfo.email)) {
        const enteredEmail = this.state.fleetManagerInfo.email.trim();
        const normalizedEmail = enteredEmail.toLowerCase();
        const emailExistsInClient =
          (fleetManagerList || []).some(
            (x) => x?.email?.trim().toLowerCase() === normalizedEmail
          ) ||
          (techSuperintendentList || []).some(
            (x) => x?.email?.trim().toLowerCase() === normalizedEmail
          ) ||
          (techExecutiveList || []).some(
            (x) => x?.email?.trim().toLowerCase() === normalizedEmail
          );

        if (emailExistsInClient) {
          swal(
            "Error!",
            `User with email ${enteredEmail} already exists in this client.`,
            "warning"
          );
          return;
        }

        let url2 = `${API.userExist}?Mail=${this.state.fleetManagerInfo.email}`;
        axios
          .get(url2, {
            headers: {
              key: currentUser.accessToken,
            },
          })
          .then((response) => {
            if (response.data === true) {
              this.state.fleetManagerArray.push(this.state.fleetManagerInfo);
              this.props.dispatch({
                type: "GetFleetManagerlist",
                data: this.state.fleetManagerArray,
              });
              this.hideSidePanel();
            } else if (response.data === false) {
              swal(
                "Error!",
                "User already exists.",
                "warning"
              );
              this.state.fleetManagerInfo.email = "";
              this.setState({});
            }
            dispatch({
              type: "getUserExistListSuccess",
              data: response.data,
            });
          })
          .catch((error) => {
            dispatch({
              type: "getUserExistListFailure",
              data: "error",
            });
          });
      }
      else {
        swal("Error!", "Invaid email format", "warning");
      }
    } else {
      swal("Error!", "Email is mandatory", "warning");
    }
  }

  updateFleetManager() {
    let emailregex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const { fleetManagerInfo, index } = this.state;
    const {
      dispatch,
      fleetManagerList,
      techSuperintendentList,
      techExecutiveList,
    } = this.props;
    if (this.state.fleetManagerInfo.email !== "") {
      if (emailregex.test(this.state.fleetManagerInfo.email)) {
        const enteredEmail = this.state.fleetManagerInfo.email.trim();
        const normalizedEmail = enteredEmail.toLowerCase();
        const emailExistsInClient =
          (fleetManagerList || []).some(
            (x, i) =>
              i !== index &&
              x?.email?.trim().toLowerCase() === normalizedEmail
          ) ||
          (techSuperintendentList || []).some(
            (x) => x?.email?.trim().toLowerCase() === normalizedEmail
          ) ||
          (techExecutiveList || []).some(
            (x) => x?.email?.trim().toLowerCase() === normalizedEmail
          );

        if (emailExistsInClient) {
          swal(
            "Error!",
            `User with email ${enteredEmail} already exists in this client.`,
            "warning"
          );
          return;
        }

        let url2 = `${API.userExist}?Mail=${this.state.fleetManagerInfo.email}`;
        axios
          .get(url2, {
            headers: {
              key: currentUser.accessToken,
            },
          })
          .then((response) => {
            if (response.data === true) {
              this.state.fleetManagerArray[index] = fleetManagerInfo;
              this.setState({});
              this.props.dispatch({
                type: "GetFleetManagerlist",
                data: this.state.fleetManagerArray,
              });
              this.hideSidePanel();
            } else if (response.data === false) {
              swal(
                "Error!",
                "User already exist. Please change the email",
                "warning"
              );
              this.state.fleetManagerInfo.email = "";
              this.setState({});
            }
            dispatch({
              type: "getUserExistListSuccess",
              data: response.data,
            });
          })
          .catch((error) => {
            dispatch({
              type: "getUserExistListFailure",
              data: "error",
            });
          });
      }
      else {
        swal("Error!", "Invalid email format", "warning");
      }
    } else {
      swal("Error!", "Email is mandatory", "warning");
    }
  }

  hideSidePanel() {
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.push("/Home/Management/ClientAdd");
  }

  render() {
    const { EditUser } = this.props;
    return (
      <div className="full-height">
        <div className="resource-list-auth-date row pt-3 ">
          <div className="w-100">
            <div className="panel-box search-filter-box">
              <button
                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                onClick={() => this.hideSidePanel()}
              >
                <div style={{ position: 'relative' }}>
                  <span className="backarr">&larr;</span> <span style={{ marginLeft: "18px" }}>Return</span>
                </div>
              </button>
              <div
                className="card mt-2 MM-card-header"
                style={{ backgroundColor: "white" }}
              >
                <div
                  className="card-body"
                  style={{
                    padding: "0rem",
                    backgroundColor: "#1a3464",
                    color: "white",
                  }}
                >
                  <h5
                    className="card-title ml-4 mt-2"
                    style={{ color: "092a51" }}
                  >
                    Marine Managers
                  </h5>
                </div>
              </div>
              <div className="row search-filter-box">
                <div className="col-lg-6">
                  <label className="form-label">Name</label>
                  <br></br>
                  <input
                    type="text"
                    className="form-control"
                    name="userName"
                    value={this.state.fleetManagerInfo.userName}
                    placeholder="Name"
                    onChange={(e) => this.handleInputChange(e)}
                  ></input>
                </div>
                <div className="col-lg-6">
                  <label className="form-label">Email<span className="mandatory">*</span></label>
                  <br></br>
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    value={this.state.fleetManagerInfo.email}
                    placeholder="Email"
                    onChange={(e) => this.handleInputChange(e)}
                  ></input>
                </div>
                <div className="col-lg-6">
                  <label className="form-label">Phone</label>
                  <br></br>
                  <input
                    type="text"
                    className="form-control"
                    name="telephone"
                    value={this.state.fleetManagerInfo.telephone}
                    placeholder="Phone"
                    onChange={(e) => this.handleInputChange(e)}
                  ></input>
                </div>
                <div className="col-lg-12 mt-2 search-filter-box">
                  <div className="search-btn-col" style={{ textAlign: "end" }}>
                    {!EditUser ? (
                      <button
                        className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                        type="submit"
                        onClick={() => this.addFleetManager()}
                      >
                        {" "}
                        Add{" "}
                      </button>
                    ) : (
                      <button
                        className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                        type="submit"
                        onClick={() => this.updateFleetManager()}
                      >
                        {" "}
                        Update{" "}
                      </button>
                    )}
                    <button
                      className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                      type="button"
                      onClick={() => this.hideSidePanel()}
                    >
                      {" "}
                      Cancel{" "}
                    </button>
                  </div>
                </div>
              </div>
              {/* <div className="row">
                <div className="col-lg-12 search-filter-box">
                  <div className="search-btn-col" style={{ textAlign: "end" }}>
                    {!EditUser ? (
                      <button
                        className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                        type="submit"
                        onClick={() => this.addFleetManager()}
                      >
                        {" "}
                        Add{" "}
                      </button>
                    ) : (
                      <button
                        className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                        type="submit"
                        onClick={() => this.updateFleetManager()}
                      >
                        {" "}
                        Update{" "}
                      </button>
                    )}
                    <button
                      className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                      type="button"
                      onClick={() => this.hideSidePanel()}
                    >
                      {" "}
                      Cancel{" "}
                    </button>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    fleetManagerList: state.MasterScreenReducer.fleetManagerlist,
    techSuperintendentList: state.MasterScreenReducer.TechSuperintendentlist,
    techExecutiveList: state.MasterScreenReducer.TechExecutivelist,
    fleetManagerDetail: state.MasterScreenReducer.fleetManagerDetail,
    EditUser: state.MasterScreenReducer.EditUser,
  };
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(newFleetManager)
);
